/**
 * @license
 * Copyright Google LLC All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.dev/license
 */

import {type Provider} from '@angular/core';
import type {FormFieldBinding} from '../api/types';
import {SIGNAL_FORMS_CONFIG} from '../field/di';

/**
 * Configuration options for signal forms.
 *
 * @publicApi 22.0
 */
export interface SignalFormsConfig {
  /** A map of CSS class names to predicate functions that determine when to apply them. */
  classes?: {
    [className: string]: (formField: FormFieldBinding) => boolean;
  };
}

/**
 * Provides configuration options for signal forms.
 *
 * @publicApi 22.0
 */
export function provideSignalFormsConfig(config: SignalFormsConfig): Provider[] {
  return [{provide: SIGNAL_FORMS_CONFIG, useValue: config}];
}
